import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { getNominative } from '@lmc/common/utils'
import CarePlanHistoryItem from './CarePlanHistoryItem'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'

export default class CarePlanHistoryList extends React.Component {
  state = {
    itemsLimit: 10,
  }

  increaseItemsLimit = () => {
    this.setState((prevState) => ({
      itemsLimit: prevState.itemsLimit + 10,
    }))
  }

  getLimitedHistory = (history, limit) =>
    Object.keys(history)
      .slice(0, limit)
      .reduce((limited, current) => {
        limited[current] = history[current]
        return limited
      }, {})

  renderHistory = (history) => {
    const { carers, onClickRevision } = this.props
    return (
      <div>
        {Object.keys(history).map((month, i) => {
          const revisions = history[month]

          if (!revisions?.length) {
            return null
          }
          return (
            <CarePlanHistoryItem
              carers={carers}
              key={i}
              onClickRevision={onClickRevision}
              style={styles.historyItem}
              title={month}
              revisions={revisions}
            />
          )
        })}
      </div>
    )
  }

  render() {
    const { history, carePlanNominative } = this.props
    const limitedHistory = this.getLimitedHistory(
      history,
      this.state.itemsLimit
    )
    if (!history || !Object.keys(history).length) {
      return (
        <EmptyState
          title="Nothing to see here!"
          icon={<NoDataIcon />}
          description={getHistoricalRevision(carePlanNominative)}
        >
          <a href={SUPPORT_ARTICLE} target="_blank" rel="noreferrer">
            Find out more
          </a>
        </EmptyState>
      )
    }
    return (
      <div>
        {this.renderHistory(limitedHistory)}
        {Object.keys(history).length > 10 && (
          <a
            id="history-show-more"
            onClick={this.increaseItemsLimit}
            style={styles.showMore}
          >
            Show more...
          </a>
        )}
      </div>
    )
  }
}

const getHistoricalRevision = (carePlanNominative) =>
  `Use this page to view the historical revisions of this ${getNominative(
    carePlanNominative,
    'Care Plan'
  )}.`

const SUPPORT_ARTICLE =
  'https://support.logmycare.co.uk/en/articles/3353625-how-can-i-view-older-versions-of-a-care-plan'

const styles = {
  blankState: {
    marginTop: 25,
  },
  historyItem: {
    marginTop: 5,
  },
  showMore: {
    color: colors.pink,
    display: 'block',
    marginTop: 25,
  },
}

CarePlanHistoryList.propTypes = {
  carers: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  carePlanNominative: PropTypes.string.isRequired,
  onClickRevision: PropTypes.func.isRequired,
}
